import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';
import Homepage from '../pages/home/home';
import ServicesPage from '../pages/services/services';
import ContactPage from '../pages/contact/contact';
import AboutPage from '../pages/about/about';
import MarketPage from '../pages/market/market';
import MarketDetail from '../pages/market/marketdetail';
import TvSlideShow from '../pages/tv/tv';

const Root = () => {
  const location = useLocation();
  const isTvPage = location.pathname === '/tv';

  // 👉 Als het de TV-pagina is, render dan enkel de TVSlideshow zonder layout
  if (isTvPage) {
    return (
      <Routes>
        <Route path="/tv" element={<TvSlideShow />} />
      </Routes>
    );
  }

  // Alle andere pagina’s met standaard layout
  return (
    <div className="page-wrapper">
      <Header />
      <main id="content">
        <Routes>
          <Route path="/onze-diensten" element={<ServicesPage />} />
          <Route path="/over-ons" element={<AboutPage />} />
          <Route path="/tweedehands" element={<MarketPage />} />
          <Route path="/tweedehands/:id" element={<MarketDetail />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/" element={<Homepage />} />
          <Route path="*" element={<Homepage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default Root;
